import { css, hex2rgba, Mode, styled } from 'canoe';

export const SelectCard = styled.button<{
  active: boolean;
  size?: string;
  type?: 'button';
  mode?: Mode;
}>`
  ${({ theme, active, mode }) => css`
    appearance: none;
    outline: none;
    align-items: center;
    background-color: ${theme.colors.Transparent};
    border-radius: ${theme.borderRadius.small};
    cursor: pointer;
    flex: 1;
    flex-direction: column;
    font-size: ${theme.fonts.small.fontSize};
    display: flex;
    text-align: center;
    justify-content: space-evenly;
    padding: ${theme.spaces.xs};

    ${
      mode === 'Dark'
        ? css`
            border: 1px solid ${theme.colors.OnyxGrayL10};
            color: ${theme.colors.White};
          `
        : css`
            border: 1px solid ${theme.colors.GlitterGrayD10};
          `
    }

    transition: ${theme.transitions.default()};

    > svg {
      margin: ${theme.spaces.xs} 0;
    }

    ${
      active &&
      css`
        border: 1px solid ${theme.colors.AquaTeal};
        box-shadow: ${theme.boxShadow.outline(theme.colors.AquaTeal)};
      `
    }
    &:focus {
      outline: 0 none;
    }

    &:hover,
    &:focus {
      border: 1px solid ${theme.colors.AquaTeal};
      background: ${hex2rgba(theme.colors.AquaTealL10, 0.08)};
    }

    &:disabled {
      background-color: ${theme.colors.GlitterGrayL30};
      border-color: ${theme.colors.GlitterGrayL20};
      cursor: not-allowed;
    }
  `}
`;
